import Label from "components/Label/Label";
import React, { ChangeEvent, FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet-async";
import { avatarImgs } from "contains/fakeData";
import UserService from "app/services/userService";
import Notify from "components/Notify";
import { toast } from "react-hot-toast";
import Dash from "containers/dash";

export interface AccountPageProps {
  className?: string;
}

interface UserData{
    id: number;
    username: string;
    nbProduct: number;
    firstname: string;
    lastname: string;
    email: string
  

}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {
    const [userData, setUserData] = useState<UserData>()
    const [photo, setPhoto] = useState<any>()
    const [username, setUsername] = useState<string>("")
    const [firstname, setFirstname] = useState<string>("")
    const [lastname, setLastname] = useState<string>("")
    const [email, setEmail] = useState<string>("")
    const [about, setAbout] = useState<string>("")
    const [genre, setGenre] = useState<string>("Female")
    const [phone, setPhone] = useState<string>("")
    const [address, setAddress] = useState<string>("")
    const [birth, setBirth] = useState<string>("")

    useEffect(() => {
        UserService.get().then(data => {
            
            setUserData(data)
            setPhoto(`/api/media/avatar/${data.username}`)
            setUsername(data.username)
            setFirstname(data.firstname)
            setLastname(data.lastname)
            setEmail(data.email)
            setAbout(data.about || "")
            setGenre(data.genre || "")
            setPhone(data.phone || "")
            setAddress(data.address || "")
            setBirth(data.birth || "")
            console.log(data)
        })
    }, [])

    const selectFileHandler = (event: ChangeEvent<HTMLInputElement>) =>{
        const { files } = event.target;

        if(files && files[0]){

            
            setPhoto(URL.createObjectURL(files[0]))
            const fd = new FormData();
            fd.append('file',  files[0])
            UserService.updateAvatar(fd).then(data => console.log(data))
            // axios.post(`${apiUrl}/api/media/product`, fd, {
            //     headers: {
            //         'Authorization': `Bearer ${loginData.token}`, // notice the Bearer before your token
            //     }
            // } ).then(
            //     response =>  {
            //         const data = response.data
            //         setPhotos(photos => [... photos, data])
            //     }
            // )


        }

    }
    const saveHandler = () =>{
      const data = {
        firstname:firstname,
        lastname: lastname,
        about: about,
        genre: genre,
        phone: phone,
        address: address,
        birth: birth
      }
      console.log(data)
      UserService.update(data).then(data => {
            
  
        if(data == 'ok'){
          toast.custom((t) => (
            <Notify 
                t={t}
                message="Votre profil a été mis à jour!"
                status ='success'
            />),
            { position: "top-right", id: "nc-product-notify", duration: 3000 }
          )
        }else{
          toast.custom((t) => (
            <Notify 
                t={t}
                message="Un problème s'est produit!"
                status ='warning'
            />),
            { position: "top-right", id: "nc-product-notify", duration: 3000 }
          )
        }
      })
 
    }
    return (
      <Dash>
    <div className={`nc-AccountPage p-10 ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Roupa | Profil </title>
      </Helmet>
      
        <div className="space-y-10 sm:space-y-12">
          {/* HEADING */}
          <h2 className="text-2xl sm:text-3xl font-semibold">
            Information sur le compte
          </h2>
          <div className="flex flex-col md:flex-row">
            <div className="flex-shrink-0 flex items-start">
              {/* AVATAR */}
              <div className="relative rounded-full overflow-hidden flex">
                <img
                  src={photo}
                  alt=""
                  className="w-32 h-32 rounded-full object-cover z-0"
                />
                <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span className="mt-1 text-xs">Change Image</span>
                </div>
                <input
                  type="file"
                  id="dropzone-file" onChange={selectFileHandler}
                  className="absolute inset-0 opacity-0 cursor-pointer"
                />
              </div>
            </div>
            <div className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6">
              <div>
                <Label>Username</Label>
                <Input className="mt-1.5" defaultValue={username} />
              </div>
              <div>
                <Label>Nom</Label>
                <Input className="mt-1.5" value={lastname} onChange={e => setLastname(e.target.value)}/>
              </div>
              <div>
                <Label>Prénom</Label>
                <Input className="mt-1.5" value={firstname}  onChange={e => setFirstname(e.target.value)} />
              </div>

              {/* ---- */}

              {/* ---- */}
              <div>
                <Label>Email</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-envelope"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    defaultValue={email} 

                  />
                </div>
              </div>

              {/* ---- */}
              <div className="max-w-lg">
                <Label>Date de naissance</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-calendar"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    type="date"
                    value={birth}
                    onChange={e => setBirth(e.target.value)}
                  />
                </div>
              </div>
              {/* ---- */}
              <div>
                <Label>Adresse</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-map-signs"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    value={address}
                    onChange={e => setAddress(e.target.value)}
                  />
                </div>
              </div>

              {/* ---- */}
              <div>
                <Label>Genre</Label>
                <Select className="mt-1.5" value={genre} onChange={e => {console.log(e.target.value);setGenre(e.target.value)}}>
                  <option value="Male">Mâle</option>
                  <option value="Female">Femme</option>
                </Select>
              </div>

              {/* ---- */}
              <div>
                <Label>Téléphone</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                    <i className="text-2xl las la-phone-volume"></i>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                  />
                </div>
              </div>
              {/* ---- */}
              <div>
                <Label>À propos</Label>
                <Textarea className="mt-1.5" value={about}  onChange={e => setAbout(e.target.value)}/>
              </div>
              <div className="pt-2">
                <ButtonPrimary onClick={saveHandler}>Sauvegarder</ButtonPrimary>
              </div>
            </div>
          </div>
        </div>
      
    </div>
    </Dash>
  );
};

export default AccountPage;
